import httpCommon from "./http-common";

// Get all chart of accounts for a business
const getAllChartOfAccounts = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/chartOfAccounts/${businessId}?skip=${skip}&limit=${limit}`);
};

// Get all default chart of accounts
const getAllDefaultChartOfAccounts = (skip = 0, limit = 50) => {
  return httpCommon.get(`/v1/get/defaultChartOfAccounts?skip=${skip}&limit=${limit}`);
};

// Search chart of accounts by code or name
const searchChartOfAccounts = (searchTerm: string, type: 'default' | 'business', businessId?: number, skip = 0, limit = 50) => {
  const encodedSearchTerm = encodeURIComponent(searchTerm);
  if (type === 'business' && businessId) {
    return httpCommon.get(`/v1/search/chartOfAccounts/${businessId}?search=${encodedSearchTerm}&skip=${skip}&limit=${limit}`);
  } else {
    return httpCommon.get(`/v1/search/defaultChartOfAccounts?search=${encodedSearchTerm}&skip=${skip}&limit=${limit}`);
  }
};

// Get chart of account by ID
const getChartOfAccountById = (publicId: string) => {
  return httpCommon.get(`/v1/get/chartOfAccount/${publicId}`);
};

// Create chart of account
const createChartOfAccount = (data: any, businessId: number) => {
  return httpCommon.post(`/v1/add/chartOfAccount/${businessId}`, data);
};

// Update chart of account
const updateChartOfAccount = (publicId: string, data: any) => {
  return httpCommon.put(`/v1/update/chartOfAccount/${publicId}`, data);
};

// Delete chart of account
const deleteChartOfAccount = (publicId: string) => {
  return httpCommon.delete(`/v1/delete/chartOfAccount/${publicId}`);
};

// Get all business chart of accounts
const getAllBusinessChartOfAccounts = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/businessChartOfAccounts/${businessId}?skip=${skip}&limit=${limit}`);
};

// Get business chart of account by ID
const getBusinessChartOfAccountById = (id: number) => {
  return httpCommon.get(`/v1/get/businessChartOfAccount/${id}`);
};

// Create business chart of account
const createBusinessChartOfAccount = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/businessChartOfAccount/${businessId}`, data);
};

// Remove chart of account from business
const removeChartOfAccountFromBusiness = (businessId: number, chartOfAccountId: string) => {
  return httpCommon.delete(`/v1/remove/chartOfAccount/${businessId}/${chartOfAccountId}`);
};

const ChartOfAccountsService = {
  getAllChartOfAccounts,
  getAllDefaultChartOfAccounts,
  getChartOfAccountById,
  createChartOfAccount,
  updateChartOfAccount,
  deleteChartOfAccount,
  getAllBusinessChartOfAccounts,
  getBusinessChartOfAccountById,
  createBusinessChartOfAccount,
  removeChartOfAccountFromBusiness,
  searchChartOfAccounts,
};

export default ChartOfAccountsService; 